// extracted by mini-css-extract-plugin
export default {"section":"page-section_section__BHvop","section_cases":"page-section_section_cases__N3uDD","section_hero_description":"page-section_section_hero_description__ucEa7"};